module.exports = __webpack_public_path__ + "img/7.1f28e609.png";